export interface Country {
    name: string;
    shortName: string;
    slug: string;
    flag: string;
    currency: string;
    currencySign: string;
    phoneCode: string;
    label: string;
    value: string;
}

export const supportedCountries: Country[] = [
    {
        name: 'United Kingdom',
        shortName: 'the UK',
        slug: 'en-GB',
        flag: '🇬🇧',
        currency: 'GBP',
        currencySign: '£',
        phoneCode: '+44',
        label: '🇬🇧 United Kingdom',
        value: 'GB',
    },
    {
        name: 'United States',
        shortName: 'the US',
        slug: 'en-US',
        flag: '🇺🇸',
        currency: 'USD',
        currencySign: '$',
        phoneCode: '+1',
        label: '🇺🇸 United States',
        value: 'US',
    },
];